import { render, staticRenderFns } from "./ResetPasswordLinkGen.vue?vue&type=template&id=7fdfe8fe&"
import script from "./ResetPasswordLinkGen.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordLinkGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports